import React from 'react'
import LeftSideBar from '../../../Components/Common/LeftSideBar'
import Footer from '../../../Components/Common/Footer'
import TopBar from '../../../Components/Common/TopBar'
import PageHeader from '../../../Components/Common/PageHeader'
import functions from '../../../utils/functions'
import RightSideBar from '../../../Components/Common/RightSideBar'
import ConfigMenu from '../../../Components/ConfigMenu'
import ajax from '../../../utils/ajax'
// import ActivityLoader from '../../../Components/Common/ActivityLoader'
import TextInput from '../../../Components/Common/TextInput'
import dictionary from '../../../utils/dictionary'
import AlertSuccess from '../../../Components/Common/AlertSuccess'
import AlertError from '../../../Components/Common/AlertError'

class CreateDevice extends React.Component {

  state = {
    userId: functions.sessionGuard(),
    deviceNumber: '',
    lat: '',
    lng: '',
    info: ''
  }



  onChangeDeviceNumber = (event) => {
    this.setState({ deviceNumber: event.target.value })
  }



  onSave = async (event) => {
    event.preventDefault();
    const { deviceNumber } = this.state;

    if (deviceNumber.length > 0) {
      //fetch login from the API
      const server_response = await ajax.createDevice(deviceNumber);
      if (server_response.status === "OK") {
        this.setState({
          info: <AlertSuccess message={server_response.details.message} />
        })
        this.setState({
          deviceNumber: ''
        })

      } else {

        this.setState({
          info: <AlertError message={server_response.details.message} />
        })

      }

    } else {
      this.setState({
        info: <AlertError message={dictionary._completeFields} />,
        loading: ''
      })
    }


  }

  render() {
    return (
      <div className="page">
        <LeftSideBar />
        <div className="main-content side-content pt-0" onClick={functions.closeSystemDrawer}>
          <TopBar />
          <div className="container-fluid">
            <PageHeader
              title="New Device"
              previousPageTitle="Devices"
              back="/config/devices"
            />

            <div className="row">
              <div className="col-xl-9 col-lg-12">
                <div className="row">

                  <div className="col-sm-12 col-xl-12 col-lg-12">
                    <div className="card custom-card">
                      <div className="card-body">
                        {this.state.info}
                        <form method="post" onSubmit={this.onSave}>


                          <TextInput
                            label="Device Number"
                            type="text"
                            onChange={() => this.onChangeDeviceNumber}
                            value={this.state.deviceNumber}
                          />



                          <div className="modal-footer">
                            <input className="btn ripple btn-success" type="button" value="Save Device" onClick={this.onSave} />
                          </div>
                        </form>

                      </div>
                    </div>


                  </div>
                </div>

              </div>

              <ConfigMenu />



            </div>


          </div>
        </div>
        <RightSideBar />
         
      </div>


    );

  }
}

export default CreateDevice
